import { useState, useMemo } from 'react'
import featuredCentersSearch from '../utils/search/featuredCentersSearch'
import { Center, SearchState } from '../types/models'
import { getCenterSearchRadiusByLocationTypeInMeters } from '../domain/useCases/getCenterSearchRadiusByLocationType'
import { Location } from '../types/models/Location.model'
import { sortFeaturedCentersByScore } from '@/domain/useCases/score/sortFeaturedCentersByScore'
import { isLocationPageType } from '@/domain/useCases/pageTypeCheck'
import { PageType } from '@/types/models/PageType.model'

type error = null | { error: unknown }

export interface UseFeaturedCentersParams {
  location: Location
  termAttr: string
  termValue: string
  searchState: SearchState
  pageType: PageType
}

interface UseFeaturedCentersReturn {
  isLoading: boolean
  centers: Center[]
  error: error
}
export default function useFeaturedSUDCenters({
  location,
  termAttr,
  termValue,
  searchState,
  pageType
}: UseFeaturedCentersParams): UseFeaturedCentersReturn {
  const { type, address_parts, location_address_parts, _geoloc, title } =
    location

  const locationAddressParts = location_address_parts || address_parts

  const [isLoading, setIsLoading] = useState(true)
  const [centers, setCenters] = useState<Center[]>([])
  const [error, setError] = useState<error>(null)

  const searchRadius = getCenterSearchRadiusByLocationTypeInMeters(type)

  useMemo(async () => {
    if (!isLocationPageType(pageType)) {
      return
    }
    try {
      const featuredCenters = await featuredCentersSearch({
        geoloc: _geoloc,
        locationTitle: title,
        locationAddressParts,
        termAttr,
        termValue,
        searchRadius,
        SUDFocusOnly: true
      })
      const scoredFeaturedSUDCenters = sortFeaturedCentersByScore({
        featuredCenters: featuredCenters.hits,
        searchState,
        locationType: type,
        pageType
      })
      setCenters(scoredFeaturedSUDCenters)
    } catch (error) {
      console.error('Error:', error)
      setError({ error })
    } finally {
      setIsLoading(false)
    }
  }, [termAttr, termValue])

  return {
    isLoading,
    centers,
    error
  }
}
